import React from 'react';

import '../Services.css';

function Services() {
  const serviceList = [
    {
      title: "Wash & Fold",
      desc: "Perfect for everyday wear. We wash, dry, and neatly fold your clothes so they are ready for the drawer.",
      img: "https://images.unsplash.com/photo-1545173168-9f1947eebb7f?q=80&w=500",
      icon: "fas fa-sync-alt"
    },
    {
      title: "Wash & Press",
      desc: "The complete package. Your garments are professionally laundered and pressed for a crisp, professional look.",
      img: "https://images.unsplash.com/photo-1517677208171-0bc6725a3e60?q=80&w=500",
      icon: "fas fa-tshirt"
    },
    {
      title: "Steam Press",
      desc: "Remove every wrinkle with our professional steam pressing service, ideal for shirts, suits, and formal wear.",
      img: "https://images.unsplash.com/photo-1489274495757-95c7c837b101?q=80&w=500",
      icon: "fas fa-wind"
    },
    {
      title: "Dry Cleaning",
      desc: "Deep cleaning for delicate fabrics using eco-friendly solutions to preserve texture and color.",
      img: "https://images.unsplash.com/photo-1591195853828-11db59a44f6b?q=80&w=400",
      icon: "fas fa-gem"
    },
    {
      title: "Shoe Cleaning",
      desc: "Give your sneakers or formal shoes a new life. We deep clean and sanitize all types of footwear.",
      img: "https://images.unsplash.com/photo-1653868249587-284b275a1c67?q=80&w=904&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      icon: "fas fa-shoe-prints"
    },
    {
      title: "Curtain & Carpet",
      desc: "Specialized heavy-duty cleaning to remove dust, allergens, and stains from your home fabrics.",
      img: "https://images.unsplash.com/photo-1648115315559-620fb2f655aa?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      icon: "fas fa-couch"
    },
    {
      title: "Sofa Cleaning",
      desc: "On-site deep sofa cleaning using safe chemicals to refresh your living room and remove deep-seated dirt.",
      img: "https://images.unsplash.com/photo-1686178827149-6d55c72d81df?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      icon: "fas fa-chair"
    },
    {
      title: "Bag Cleaning",
      desc: "Premium care for your luxury bags and backpacks. We handle leather and fabric with utmost precision.",
      img: "https://images.unsplash.com/photo-1548036328-c9fa89d128fa?q=80&w=500",
      icon: "fas fa-shopping-bag"
    }
  ];

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <h1>Our Premium <span>Services</span></h1>
        <p>From everyday laundry to specialized garment care, we provide the best cleaning solutions in the UAE.</p>
      </section>

      {/* Services Grid */}
      <section className="services-grid-container">
        <div className="services-grid">
          {serviceList.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-img-box">
                <img src={service.img} alt={service.title} />
                <div className="service-icon-badge">
                  <i className={service.icon}></i>
                </div>
              </div>
              <div className="service-info">
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
                <button className="btn-service-book">Book Now</button>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="comparison-premium">
  <div className="section-title-center">
    <span>Choosing Made Easy</span>
    <h2>Service Comparison</h2>
    
  </div>

  <div className="comparison-container">
    {/* Feature Names Column (Visible on Desktop) */}
    <div className="feature-labels">
      <div className="feature-label-blank"></div>
      <div className="f-label">Cleaning Method</div>
      <div className="f-label">Detergent Used</div>
      <div className="f-label">Stain Treatment</div>
      <div className="f-label">Ironing Style</div>
      <div className="f-label">Delivery Time</div>
    </div>

    {/* Standard Wash Card */}
    <div className="comp-card">
      <div className="comp-header">
        <h4>Standard</h4>
        <div className="comp-price">Basic Care</div>
      </div>
      <div className="comp-body">
        <div className="mobile-f-label">Cleaning Method</div>
        <div className="f-value">Machine Wash</div>
        
        <div className="mobile-f-label">Detergent Used</div>
        <div className="f-value">Standard Liquid</div>
        
        <div className="mobile-f-label">Stain Treatment</div>
        <div className="f-value"><i className="fas fa-minus-circle"></i></div>
        
        <div className="mobile-f-label">Ironing Style</div>
        <div className="f-value">Normal Fold</div>
        
        <div className="mobile-f-label">Delivery Time</div>
        <div className="f-value">48 Hours</div>
      </div>
    </div>

    {/* Premium Care Card - HIGHLIGHTED */}
    <div className="comp-card featured">
      <div className="featured-badge">MOST POPULAR</div>
      <div className="comp-header">
        <h4>Premium</h4>
        <div className="comp-price">Expert Care</div>
      </div>
      <div className="comp-body">
        <div className="mobile-f-label">Cleaning Method</div>
        <div className="f-value">Delicate Soft-Wash</div>
        
        <div className="mobile-f-label">Detergent Used</div>
        <div className="f-value">Bio-Organic Eco</div>
        
        <div className="mobile-f-label">Stain Treatment</div>
        <div className="f-value">Pre-Treatment <i className="fas fa-check-circle"></i></div>
        
        <div className="mobile-f-label">Ironing Style</div>
        <div className="f-value">Steam Press</div>
        
        <div className="mobile-f-label">Delivery Time</div>
        <div className="f-value">24 Hours</div>
      </div>
    </div>

    {/* Dry Cleaning Card */}
    <div className="comp-card">
      <div className="comp-header">
        <h4>Dry Clean</h4>
        <div className="comp-price">Luxury Care</div>
      </div>
      <div className="comp-body">
        <div className="mobile-f-label">Cleaning Method</div>
        <div className="f-value">Solvent Based</div>
        
        <div className="mobile-f-label">Detergent Used</div>
        <div className="f-value">Fabric Protectors</div>
        
        <div className="mobile-f-label">Stain Treatment</div>
        <div className="f-value">Expert Removal <i className="fas fa-check-circle"></i></div>
        
        <div className="mobile-f-label">Ironing Style</div>
        <div className="f-value">Hand Press</div>
        
        <div className="mobile-f-label">Delivery Time</div>
        <div className="f-value">3-4 Days</div>
      </div>
    </div>
  </div>
</section>
    </div>
  );
}

export default Services;